import React, { PureComponent } from "react";

class RegistrationSuccess extends PureComponent {
  render() {
    return (
      <div>
        Thank you! We have sent an email verification to your email address.
      </div>
    );
  }
}

export default RegistrationSuccess;



// WEBPACK FOOTER //
// ./src/pages/account/register/components/RegistrationSuccess.js